/**
 * Map API → form `submittedBy` (Submitted By UI).
 * Prefer display name columns from DB; `submittedBy` in JSON is often email/audit — use only as fallback.
 */
export function mapMaintenanceRecordSubmittedByFromApi(record) {
  if (!record || typeof record !== 'object') {
    return record;
  }
  const fromMaintenanceColumn =
    record.maintenanceSubmittedBy ??
    record.MaintenanceSubmittedBy ??
    record.maintennaceSubmittedBy ??
    record.MaintennaceSubmittedBy ??
    record.maintennace_submitted_by;

  const trimmed =
    fromMaintenanceColumn != null && String(fromMaintenanceColumn).trim() !== ''
      ? String(fromMaintenanceColumn).trim()
      : '';

  const submittedBy =
    trimmed !== ''
      ? trimmed
      : record.submittedBy != null && String(record.submittedBy).trim() !== ''
        ? String(record.submittedBy).trim()
        : '';

  return { ...record, submittedBy };
}

export function mapMaintenanceListSubmittedByFromApi(payload) {
  if (Array.isArray(payload)) {
    return payload.map(mapMaintenanceRecordSubmittedByFromApi);
  }
  return mapMaintenanceRecordSubmittedByFromApi(payload);
}
